export default __webpack_public_path__ + "static/blob5-68bda534ecd5f38bf7bc01eef4e27217.svg";